var Auth = require('../api/Auth');
var Invocation = require('../api/Invocation');

var UserActions = {
    getUser: function (token) {
        Auth.getUser(token);
    },
    refreshHmac: function () {
        Invocation.auth.refreshHmac();
    }
};
module.exports = UserActions;



// WEBPACK FOOTER //
// ./app/actions/UserActions.js